import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24344 37469"
    {...props}
  >
    <path
      d="M0 18743c0-4414 453-7984 1358-10683 914-2708 2264-4789 4057-6243C6474 955 7699 349 9087 0v4230c-767 444-1442 1080-2026 1906-1576 2272-2359 6486-2359 12625 0 6155 713 10247 2151 12267 670 948 1416 1673 2234 2177v4263c-2170-544-3970-1706-5395-3488C1228 30846 0 25769 0 18743zM15257 6c781 199 1515 481 2200 845 1515 809 2769 1976 3744 3500 975 1515 1741 3370 2298 5554 566 2186 845 5138 845 8838 0 4388-453 7941-1349 10640-897 2708-2247 4788-4040 6251-1064 871-2297 1483-3698 1835v-4268c818-506 1563-1234 2235-2181 1437-2038 2150-6121 2150-12259 0-6156-713-10248-2150-12268-666-946-1412-1670-2235-2175V6z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
